import { CidadesEstado, estadosV2, getCidadesByUf } from '@acme/common'
import Grid from '@/global/components/ui/Grid'
import dayjs from 'dayjs'
import {
    FormDatePicker,
    FormField,
    FormFieldAutocomplete,
    FormFieldCheckbox,
    FormFieldSelect,
} from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import {
    CreateFeriadoInput,
    createFeriadoSchema,
    feriadosCliente,
} from 'service/api'
import { toast } from 'sonner'

export default function AdicionarFeriadoModal() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const navigate = useNavigate()
    const [cidades, setCidades] = useState<CidadesEstado[]>([])

    const { mutate } = feriadosCliente.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleChangeUf = async (uf: string) => {
        const cidades = await getCidadesByUf(uf)
        setCidades(cidades)
    }

    const handleClose = () => navigate(-1)

    const handleSubmit: SubmitHandler<CreateFeriadoInput> = ({
        data,
        Cidade,
        repetir,
        ...rest
    }) => {
        data = new Date(
            data.getTime() + Math.abs(data.getTimezoneOffset() * 60000),
        )

        mutate(
            {
                ...rest,
                ...Cidade,
                clienteId,
                mes: Number(dayjs(data).format('MM')),
                dia: Number(dayjs(data).format('DD')),
                ano: repetir ? null : Number(dayjs(data).format('YYYY')),
            },
            {
                onSuccess: () => {
                    toast.success('Feriado cadastrado com sucesso!')
                    handleClose()
                },
                onError: () => {
                    toast.error('Erro ao cadastrar o feriado!')
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['create', 'Feriados'])}
            width="xl"
            onSubmit={handleSubmit}
            schema={createFeriadoSchema}
        >
            <Dialog.Title>Cadastrar feriado</Dialog.Title>
            <Dialog.Content>
                <Grid container className="mb-2">
                    <Grid item xs={12}>
                        <FormField
                            name="nome"
                            label="Nome do Feriado"
                            required
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={7}>
                        <FormDatePicker
                            name="data"
                            label="Data"
                            required
                            type="date"
                        />
                    </Grid>
                    <Grid item xs={5}>
                        <FormFieldCheckbox
                            name="repetir"
                            label="Repetir todos os anos"
                            defaultChecked={true}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormFieldSelect
                            name="uf"
                            label="UF"
                            required
                            options={estadosV2.map(({ sigla }) => ({
                                value: sigla,
                                label: sigla,
                            }))}
                            onChange={handleChangeUf}
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <FormFieldAutocomplete
                            name="Cidade"
                            label="Cidade"
                            options={cidades.map(cidade => ({
                                cidade: cidade.nome,
                                ibge: cidade.id,
                            }))}
                            required
                            getOptionLabel={option => option.cidade}
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
